// Images
import Generating from '../../static/images/generating.gif';
import NoResult from '../../static/images/noDataFound.png';

// Custom hooks
import { useInterval } from '../../hooks/customHooks';

// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Styles
import './ViewDownloadGeneric.scss';

const REFRESH_INTERVAL = 20000;

const ViewDownloadStatus = props => {
    const { data, downloadReportRequest, getActiveReportRequest } = props;
    const isGeneratingData = data && data.generating && data.generating.length;
    const isCompleteData = data && data.complete && data.complete.length;

    // eslint-disable-next-line space-before-function-paren
    useInterval(async () => {
        if (isGeneratingData) {
            await getActiveReportRequest(true);
        }
    }, REFRESH_INTERVAL);

    useEffect(() => {
        getActiveReportRequest();
    }, []);

    const handleDownload = item => {
        if (item.requestId) {
            downloadReportRequest(item);
        }
    };

    return (
        <div className="view-download-status">
            {data ? (
                <>
                    {isGeneratingData ? (
                        <div className="status-text">
                            Your File is{' '}
                            <span className="warn">Generating…… </span>
                            <br />
                            you can download it when it will be completed
                        </div>
                    ) : null}
                    {isGeneratingData ? (
                        <div className="download-list generating">
                            <h2>Generating File</h2>
                            <ul>
                                {data.generating.map((item, index) => (
                                    <li key={`file-pending-${index}`}>
                                        <div className="file-name">
                                            {item.fileName}
                                        </div>
                                        <div className="status-icon loading">
                                            <img
                                                src={Generating}
                                                alt="File Generating"
                                            />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}
                    {isCompleteData ? (
                        <div className="download-list">
                            <h2>Recent File</h2>
                            <ul>
                                {data.complete &&
                                    data.complete.map((item, index) => (
                                        <li key={`file-completed-${index}`}>
                                            <div className="file-name">
                                                {item.fileName}
                                            </div>
                                            <div className="status-icon">
                                                <button
                                                    className="download"
                                                    onClick={() =>
                                                        handleDownload(item)
                                                    }
                                                />
                                            </div>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    ) : null}
                </>
            ) : (
                <div className="no-result">
                    <img src={NoResult} alt="No Result" />
                    No Generated files found.
                </div>
            )}
        </div>
    );
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

ViewDownloadStatus.propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    downloadReportRequest: PropTypes.func,
    getActiveReportRequest: PropTypes.func,
    data: PropTypes.object,
    refundData: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewDownloadStatus);
